import {
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Slider,
  Space,
  Spin,
  Table,
  Tag,
} from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import Button from 'components/Button';
import {
  CheckIcon,
  ChevronDown,
  ChevronUp,
  DownloadIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
  FilterIcon2,
  Remove,
} from 'assets/svg';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { useHistory } from 'react-router-dom';
import { CloseOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { CollapseProps } from 'antd/lib';
import { useMutation, useQuery } from 'react-query';
import { PORTFOLIO_STATUS } from 'constants/portfolioStatus';
import { Content } from 'antd/es/layout/layout';
import * as XLSX from 'xlsx';
import { useUser } from 'contexts/User';
import CartApi from 'apis/CartApi';
import AllocateApi from 'apis/AllocateApi';
import { defaultImage } from 'assets/images';
import ProductCartInfo from 'components/Modules/Cart/CartTVV/ProductCartInfo';
import { useForm } from 'antd/es/form/Form';
import ProductApi from 'apis/ProductApi';
import { openNotificationWithIcon } from 'utils/notification';
import { STATUS } from 'constants/reponseStatus';
import formatNumber from 'utils/formatNumber';

type FixedType = 'left' | 'right' | boolean;

interface IProps {
  cart: any;
}

const AllocateCapitalRemain = forwardRef((props: IProps, ref: any) => {
  // export default function AllocateCapitalRemain(props: IProps): JSX.Element {
  const capitalLineProduct = [
    {
      tuXman: 'Dây chuyền 416',
      tu: 2,
      sLMau: 2,
      minPlan: 2,
      minCur: 20,
      minApproval: 20,
      maxPlan: 2,
      maxCur: 20,
      maxApproval: 15352566,
    },
    {
      tuXman: 'Dây chuyền Platin',
      dVi: 'Cây dây',
      tu: 5,
      sLMau: 5,
      minPlan: 5,
      minCur: 50,
      minApproval: 50,
      maxPlan: 5,
      maxCur: 50,
      maxApproval: 15352566,
    },
    {
      tuXman: 'Dây chuyền 9999',
      dVi: 'Khay',
      tu: 1,
      sLMau: 1,
      minPlan: 1,
      minCur: 50,
      minApproval: 50,
      maxPlan: 1,
      maxCur: 50,
      maxApproval: 2445880,
    },
    {
      tuXman: 'Nhẫn vàng',
      tu: 1,
      sLMau: 1,
      minPlan: 1,
      minCur: 50,
      minApproval: 50,
      maxPlan: 1,
      maxCur: 50,
      maxApproval: 12466225,
    },
  ];

  const history = useHistory();
  const { Option } = Select;
  const { user } = useUser();
  const [form] = useForm();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [validateLoading, setValidateLoading] = useState<boolean>(false);

  const { cart } = props;

  const [selectedTags, setSelectedTags] = useState<string>();
  const [bstSelected, setBST] = useState<any>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [cart_register_detail, setCart_register_detail] = useState<any>();
  const [modalData, setModalData] = useState<any>(null);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const [searchName, setSearchName] = useState<any>();
  const [nhanhangSelected, setNhanHang] = useState<any>([]);
  const [donghangSelected, setDongHang] = useState<any>([]);
  const [nganhhangSelected, setNganhHang] = useState<any>([]);
  const [chungloaiSelected, setChungLoai] = useState<any>([]);
  const [isBoCap, setBoCap] = useState<any>();
  const [lstAllDonHang, setLstAllDonHang] = useState<any>();
  const [capitalYear, setCapitalYear] = useState<number | null>(null);
  const [isCapitalYearLoaded, setIsCapitalYearLoaded] = useState(false);

  const [isOpenFilterAdvanced, setIsOpenFilterAdvanced] =
    useState<boolean>(false);
  const toggleFilterAdvanced = () => {
    setIsOpenFilterAdvanced(!isOpenFilterAdvanced);
  };

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const userParams = {
    page: page.toString(),
    page_size: page_size.toString(),
    // shop_id: user?.plantId,
    // cart_register_id: cart.cart_register_id,
    ...(searchName && { ten_mau: searchName }),
    ...(nhanhangSelected &&
      nhanhangSelected.length != 0 && { nhan_hang: nhanhangSelected }),
    ...(donghangSelected &&
      donghangSelected.length != 0 && { dong_hang: donghangSelected }),
    ...(nganhhangSelected &&
      nganhhangSelected.length != 0 && { nganh_hang: nganhhangSelected }),
    ...(chungloaiSelected &&
      chungloaiSelected.length != 0 && { chung_loai: chungloaiSelected }),
    ...(isBoCap && isBoCap == 'is_group_bo' && { is_group_bo: true }),
    ...(isBoCap && isBoCap == 'is_group_cap' && { is_group_cap: true }),
    ...(bstSelected && { bst: bstSelected }),
    ...(formSubmitParams && formSubmitParams),
  };

  useEffect(() => {
    const branchCodeRaw = user?.branch_code ?? user?.plantCode;
    const branchCode =
      branchCodeRaw !== undefined && branchCodeRaw !== null
        ? String(branchCodeRaw)
        : undefined;

    if (!branchCode) {
      const currentYear = new Date().getFullYear();
      setCapitalYear(currentYear);
      setIsCapitalYearLoaded(true);
      return;
    }

    const fetchMaxCapitalYear = async () => {
      try {
        const response = await AllocateApi.getMaxCapitalYear(branchCode);
        const maxCapitalYear =
          response?.data?.data?.max_capital_year ??
          response?.data?.max_capital_year;

        if (maxCapitalYear !== undefined && maxCapitalYear !== null) {
          const parsedYear = Number(maxCapitalYear);
          if (!Number.isNaN(parsedYear)) {
            setCapitalYear(parsedYear);
            return;
          }
        }
        setCapitalYear(new Date().getFullYear());
      } catch (error) {
        setCapitalYear(new Date().getFullYear());
      } finally {
        setIsCapitalYearLoaded(true);
      }
    };

    fetchMaxCapitalYear();
  }, [user?.branch_code, user?.plantCode]);

  const mutationFunction = (params: any) =>
    user?.role.includes('nguoi_dat_hang') ||
    user?.role.includes('cua_hang_truong')
      ? () =>
          CartApi.getCartCHT_view({
            shop_id: user?.plantId,
            cart_register_id: cart.cart_register_id,
            ...params,
          }) // cửa hàng
      : user?.plantCode !== 1000
      ? () =>
          CartApi.getCartBranch_view({
            cart_order_branch_id: cart.id?.toString(),
            ...params,
          }) //chi nhánh
      : () => CartApi.getCartCHT_view(params); //tạm cho hội sở

  const {
    mutate: refetch,
    isLoading: getAllocationLoading,
    data: lstAllocation,
  } = useMutation(['getAllocates', page], mutationFunction(userParams));

  const { mutate: getAllDonHang, isLoading: isGetAllocationAllLoading } =
    useMutation(
      ['getAlls', page],
      mutationFunction({
        ...userParams,
        page:
          user?.role.includes('nguoi_dat_hang') ||
          user?.role.includes('cua_hang_truong')
            ? '1'
            : 1,
        page_size:
          user?.role.includes('nguoi_dat_hang') ||
          user?.role.includes('cua_hang_truong')
            ? lstAllocation?.total.toString()
            : lstAllocation?.total,
      }),
      {
        onSuccess: (response: any) => {
          if (response.status === STATUS.SUCCESS) {
            console.log('fetch export');
            setLstAllDonHang(response.data);
            exportFileExcel(response.data);
          }
        },
        onError: (error) => {
          console.log('fetch export err');
          openNotificationWithIcon('error', `Lỗi lấy dữ liệu`);
        },
      }
    );
  // const {
  //   mutate: refetch,
  //   isLoading: getAllocationLoading,
  //   data: lstAllocation,
  // } = useMutation(() => CartApi.getCartCHT_view(userParamsShop));

  useImperativeHandle(ref, () => ({
    checkBeforeSendApprove,
  }));

  const checkBeforeSendApprove = async () => {
    if (lstAllocation?.data.length == 0) {
      openNotificationWithIcon(
        'error',
        'Không thế gửi phê duyệt đơn hàng',
        'Không có sản phẩm trong giỏ hàng'
      );
    } else if (lstAllocation?.data[0].order_status != 0) {
      openNotificationWithIcon('warning', 'Giỏ hàng đã được gửi phê duyệt');
    } else {
      setValidateLoading(true);

      await CartApi.checkValidateCHT(lstAllocation?.data[0]?.cart_order_cht_id)
        .then((res) => {
          if (res.data === 'success') {
            setModalOpen(true);
          } else {
            setValidateLoading(false);

            const check = res.data?.find((item: any) => {
              return item?.isCritical === true;
            });

            if (check === undefined) {
              setModalOpen(true);
            } else {
              openNotificationWithIcon(
                'error',
                'Không đủ điều kiện đặt hàng',
                'Loại hàng đặt theo cặp, bộ'
              );
            }
          }
        })
        .catch((err) => {
          openNotificationWithIcon('error', 'Không thể gửi phê duyệt đơn hàng');
        })
        .finally(() => {
          setValidateLoading(false);
        });
    }
  };

  const requestApprovalToBranch = () => {
    if (!isCapitalYearLoaded || capitalYear === null) {
      openNotificationWithIcon('warning', 'Vui lòng chờ tải năm vốn');
      return;
    }
    CartApi.requestApprovalToBranch(
      lstAllocation?.data[0].cart_order_cht_id,
      capitalYear ?? undefined
    )
      .then((res) => {
        openNotificationWithIcon('success', 'Gửi yêu cầu thành công');
        setModalOpen(false);
      })
      .catch((err) => {
        openNotificationWithIcon('error', err.toString());
        setModalOpen(false);
      });
  };

  const sortData = [
    'Mới nhất',
    'Bán chạy',
    'Đăng ký kỳ trước',
    'Sức bán trung bình',
  ];

  const columnTops: ColumnsType<any> = [
    { title: 'Tủ Xman', dataIndex: 'tuXman', width: 90 },
    { title: 'Đơn vị tính', dataIndex: 'dVi', width: 60 },
    { title: 'Tủ', dataIndex: 'tu', width: 30 },
    { title: 'SL Mẫu', dataIndex: 'sLMau', width: 30 },
    { title: 'Min kế hoạch', dataIndex: 'minPlan', width: 60 },
    { title: 'Min hiện tại', dataIndex: 'minCur', width: 60 },
    { title: 'Min đã duyệt', dataIndex: 'minApproval', width: 60 },
    { title: 'Max kế hoạch', dataIndex: 'maxPlan', width: 60 },
    { title: 'Max hiện tại ', dataIndex: 'maxCur', width: 60 },
    {
      title: 'Vốn max kế hoạch ',
      dataIndex: 'maxApproval',
      width: 60,
      render: (_: any, record: any) => formatCurrencyVND(record.maxApproval),
    },
  ];

  const columnBottoms: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'stt',
      width: 60,
      render: (value, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
      width: 180,
    },
    {
      title: 'Tên tên mẫu',
      dataIndex: 'ten_mau',
      width: 220,
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      align: 'center',
      width: 80,
      render: (_: any, record: any) => (
        <div className="flex justify-center">
          <img
            className="rounded-lg"
            width="40px"
            height="40px"
            src={record?.image_default || defaultImage}
            alt=""
          />
        </div>
      ),
    },
    {
      title: 'Ngành hàng',
      dataIndex: 'nganh_hang',
      width: 160,
    },
    {
      title: 'Dòng hàng SAP',
      dataIndex: 'dong_hang',
      width: 120,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chungloai',
      width: 120,
    },
    {
      title: 'Giá vốn',
      dataIndex: 'cost_price',
      width: 120,
      render: (_: any, record: any) => formatCurrencyVND(record.cost_price),
    },
    {
      title: 'Min',
      dataIndex: 'order_min',
      width: 120,
    },
    {
      title: 'Max',
      dataIndex: 'order_max',
      width: 120,
    },
    {
      title: 'Vốn tồn min',
      dataIndex: 'total_capital_remain_min',
      width: 120,
      render: (_: any, record: any) =>
        formatCurrencyVND(record?.order_min * record?.cost_price),
    },
    {
      title: 'Vốn tồn max',
      dataIndex: 'total_capital_remain_max',
      width: 120,
      render: (_: any, record: any) =>
        formatCurrencyVND(record?.order_max * record?.cost_price),
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 120,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around">
          <button
            onClick={() => {
              setIsModalVisible(true);
              setCart_register_detail(record);
            }}
          >
            <EyeIcon />
          </button>
        </div>
      ),
    },
  ];
  const items_top: CollapseProps['items'] = [
    {
      key: '1',
      label: (
        <p className="text-base font-bold text-primary-50 ml-2">
          Vốn theo dòng hàng
        </p>
      ),
      children: (
        <div>
          <Table
            rowKey={(record) => record.id}
            columns={columnTops}
            size="small"
            className="customTable"
            dataSource={capitalLineProduct}
            scroll={{ x: 958 }}
            //  loading={getAllocationLoading}
            pagination={false}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    user && refetch();
  }, [page, page_size, formSubmitParams, user]);

  const handleChangeTag = (tag: string, checked: boolean) => {
    if (tag == selectedTags) {
      setSelectedTags(undefined);
    } else {
      setSelectedTags(tag);
    }
  };

  function exportFileExcel(dataExport: any) {
    const data = [];
    let index = 0;
    const headerRow = columnBottoms.filter(
      (column) => column.dataIndex != undefined
    );

    data.push(
      headerRow.map((column) => {
        return column.title;
      })
    );

    dataExport.forEach((row: any) => {
      const rowData = headerRow
        // columnBottoms
        //   .filter((column) => column.dataIndex != undefined)
        .map((column) => {
          switch (column.dataIndex) {
            case 'stt':
              return ++index;
            case 'total_capital_remain_min':
              return formatNumber(row.cost_price * row.order_min);
            case 'total_capital_remain_max':
              return formatNumber(row.cost_price * row.order_max);
            default:
              return typeof row[column.dataIndex] === 'number' ||
                !isNaN(parseFloat(row[column.dataIndex]))
                ? formatNumber(parseFloat(row[column.dataIndex]))
                : row[column.dataIndex];
          }
        });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `dang_ky_gio_hang.xlsx`);
  }

  function changeSelect() {
    console.log('change selected');
  }

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(
        ([_, value]) =>
          value !== undefined && !(Array.isArray(value) && value.length === 0)
      )
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (
        key == 'plhh' ||
        key == 'dong_hang' ||
        key == 'nganh_hang' ||
        key == 'chung_loai' ||
        key == 'loai_da' ||
        key == 'nhom_da' ||
        key == 'line_xman' ||
        key == 'material_type' ||
        key == 'kldg_3tc'
      ) {
        stringifiedData[key] = filteredData[key];
      } else if (key == 'cost_price') {
        const values: any = filteredData[key];
        stringifiedData['min_cost_price'] = values[0];
        stringifiedData['max_cost_price'] = values[1];
      } else if (key == 'price') {
        const values: any = filteredData[key];
        stringifiedData['min_price'] = values[0];
        stringifiedData['max_price'] = values[1];
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    console.log('stringifiedData', stringifiedData);
    setFormSubmitParams(stringifiedData);
    history.push(`/declare`, { cart: cart });
  };

  const { data: lstProductOption } = useQuery(
    ['getProductOption'],
    () => ProductApi.getProductOption() // lấy ds option
  );

  const pthh_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'plhh'
  );

  const plhh =
    pthh_list == undefined || pthh_list.length == 0 ? [] : pthh_list[0]['list'];

  const donghang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'line_xman'
  )[0]['list'];

  const nganhhang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nganhhang'
  )[0]['list'];

  const chungloai = lstProductOption?.data?.filter(
    (option: any) => option.type === 'chungloai'
  )[0]['list'];

  const bst = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bst'
  )[0]['list'];

  const phankhuc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'phankhuc'
  )[0]['list'];

  const costprice = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cost_price'
  )[0]['data'];

  const price = lstProductOption?.data?.filter(
    (option: any) => option.type === 'price'
  )[0]['data'];

  const loaida = lstProductOption?.data?.filter(
    (option: any) => option.type === 'loai_da'
  )[0]['list'];

  const nhomda = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nhom_da'
  )[0]['list'];

  const donghangsap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'donghang'
  )[0]['list'];

  const gioitinh = lstProductOption?.data?.filter(
    (option: any) => option.type === 'gioitinh'
  )[0]['list'];

  const bo = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bo'
  )[0]['list'];

  const cap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cap'
  )[0]['list'];

  const xman = lstProductOption?.data?.filter(
    (option: any) => option.type === 'xman'
  )[0]['list'];

  const kldg_3tc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'kldg_3tc'
  )[0]['list'];

  const materialtype_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'material_type'
  );

  const materialtype =
    materialtype_list == undefined || materialtype_list.length == 0
      ? []
      : materialtype_list[0]['list'];

  const convertStatus = (status: number) => {
    switch (status) {
      case undefined:
      case null:
      case 0:
        return 'Mới tạo';
      case 1:
        return 'CHT duyệt và gửi CN';
      case 2:
        return 'CN duyệt';
      case 3:
        return 'CN từ Chối';
      case 4:
        return 'HS duyệt';
      case 5:
        return 'HS từ chối';
      default:
        return '-';
    }
  };

  return (
    <Spin spinning={isGetAllocationAllLoading}>
      <div ref={ref} className="relative">
        {/* <p
          className={`absolute right-0 -top-14 bg-[#EAF2FF] 'text-[#00538f]' font-medium py-1 px-3 rounded-2xl`}
        >
          {convertStatus(cart.status)}
        </p> */}
        {user?.role.includes('cua_hang_truong') && (
          <Tag color="blue" className={`absolute right-0 -top-14`}>
            <strong
              style={{
                fontSize: '16px',
                paddingLeft: '10px',
                paddingRight: '10px',
              }}
            >
              {convertStatus(cart.status)}
            </strong>
          </Tag>
        )}

        {/* <Row>
          <Col span={24} className="border-2 mb-5 border-blue-100">
            <Collapse
              expandIconPosition="right"
              ghost
              expandIcon={({ isActive }) =>
                isActive ? <ChevronUp /> : <ChevronDown />
              }
              size="small"
              items={items_top}
            />
          </Col>
        </Row> */}
        <Row
          justify={'space-between'}
          style={{
            paddingBottom: '10px',
            paddingLeft: '18px',
            paddingRight: '0px',
            alignItems: 'center',
          }}
        >
          <Row gutter={25} align={'middle'}>
            {/* <Col className="font-bold">Sắp xếp</Col>
          <Space size={[0, 5]} wrap>
            {sortData.map((tag) => (
              <CheckableTag
                key={tag}
                checked={selectedTags?.includes(tag) ?? false}
                onChange={(checked) => handleChangeTag(tag, checked)}
                style={{
                  borderRadius: '10px',
                  paddingLeft: '16px',
                  paddingRight: '16px',
                  border: '#E4F3FF 1px solid',
                  backgroundColor: selectedTags?.includes(tag)
                    ? '#00538F'
                    : '#FFFFFF',
                  fontWeight: selectedTags?.includes(tag) ? '600' : '500',
                  color: selectedTags?.includes(tag) ? '#FFFFFF' : '#757779',
                }}
              >
                {tag}
              </CheckableTag>
            ))}
          </Space> */}
          </Row>
          <Space>
            <Button
              bgColor={'white'}
              color={'text-primary-50'}
              border={'border-primary-50'}
              onClick={() => getAllDonHang()}
            >
              <DownloadIcon /> Tải file Excel
            </Button>
            {/* <Button
              bgColor={'bg-white'}
              color={`${
                !isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                !isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterGoldIcon /> : <FilterIcon2 />} Lọc
            </Button>
            <Select
              placeholder="Sắp xếp nâng cao"
              className="w-full"
              allowClear
              value={bstSelected}
              onChange={(value) => {
                setBST(value);
                changeSelect();
              }}
            >
              {PORTFOLIO_STATUS.map((item) => (
                <Option value={item.values} key={item.name} defaultValue={null}>
                  {item.name}
                </Option>
              ))}
            </Select> */}
          </Space>
        </Row>
        <Form
          form={form}
          layout="vertical"
          className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Content>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                <Form.Item name="ma_mau" label="Mã mẫu">
                  <Input placeholder="Nhập mã mẫu" className="" />
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="plhh" label="Phân loại hàng hóa">
                  <Select
                    size="middle"
                    placeholder="Chọn phân loại hàng hóa"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {plhh &&
                      plhh.map((item: any) => (
                        <Option key={item.plhh} value={item.plhh}>
                          {item.plhh}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="" span={6}>
                <Form.Item name="line_xman" label="Dòng hàng Xman">
                  <Select
                    size="middle"
                    placeholder="Chọn dòng hàng"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {donghang &&
                      donghang.map((item: any) => (
                        <Option
                          key={item.line_xman_text}
                          value={item.line_xman_text}
                        >
                          {item.line_xman_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="" span={6}>
                <Form.Item name="nganh_hang" label="Ngành hàng">
                  <Select
                    size="middle"
                    placeholder="Chọn ngành hàng"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {nganhhang &&
                      nganhhang.map((item: any) => (
                        <Option key={item.prod_grp2} value={item.prod_grp2}>
                          {item.prod_grp2_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                <Form.Item name="chung_loai" label="Chủng loại SAP">
                  <Select
                    size="middle"
                    placeholder="Chọn chủng loại"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {chungloai &&
                      chungloai.map((item: any) => (
                        <Option key={item.chungloai} value={item.chungloai}>
                          {item.chungloai + ' - ' + item.chungloai_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="kldg_3tc" label="Đánh giá TQ">
                  <Select
                    size="middle"
                    placeholder="Chọn đánh giá TQ"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {kldg_3tc &&
                      kldg_3tc.map((item: any) => (
                        <Option key={item.kldg_3tc} value={item.kldg_3tc}>
                          {item.kldg_3tc}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="cost_price" label="Giá vốn bình quân">
                  {costprice && (
                    <Slider
                      min={costprice?.min}
                      max={costprice?.max}
                      range
                      step={10}
                      tooltip={{
                        formatter: (value: any) => {
                          return formatCurrencyVND(value);
                        },
                      }}
                      defaultValue={[costprice?.min, costprice?.max]}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="flex justify-end" span={24}>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-white'}
                  onClick={toggleFilterAdvanced}
                >
                  Tìm kiếm nâng cao
                  {isOpenFilterAdvanced ? <UpOutlined /> : <DownOutlined />}
                </Button>
              </Col>
            </Row>

            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              className={`items-center ${
                isOpenFilterAdvanced ? '' : 'hidden'
              } mt-4`}
            >
              <Col className="" span={6}>
                <Form.Item name="loai_da" label="Loại đá">
                  <Select
                    size="middle"
                    placeholder="Chọn loại đá"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {loaida &&
                      loaida.map((item: any) => (
                        <Option key={item.loai_da} value={item.loai_da}>
                          {item.loai_da}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="nhom_da" label="Nhóm đá">
                  <Select
                    size="middle"
                    placeholder="Chọn nhóm đá"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {nhomda &&
                      nhomda.map((item: any) => (
                        <Option key={item.nhom_da} value={item.nhom_da}>
                          {item.nhom_da}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="" span={6}>
                <Form.Item name="dong_hang" label="Dòng hàng SAP">
                  <Select
                    size="middle"
                    placeholder="Nhập dòng hàng SAP"
                    allowClear
                    mode="multiple"
                    maxTagCount="responsive"
                  >
                    {donghangsap &&
                      donghangsap.map((item: any) => (
                        <Option key={item.prod_grp4} value={item.prod_grp4}>
                          {item.prod_grp4_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="zma_bo" label="Bộ">
                  <Select size="middle" placeholder="Chọn bộ" allowClear>
                    {bo &&
                      bo.map((item: any) => (
                        <Option key={item.zma_bo} value={item.zma_bo}>
                          {item.zma_bo_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              className={`items-center ${
                isOpenFilterAdvanced ? '' : 'hidden'
              } mt-4`}
            >
              <Col className="" span={6}>
                <Form.Item name="zma_ts_cap" label="Cặp">
                  <Select size="middle" placeholder="Nhập cặp" allowClear>
                    {cap &&
                      cap.map((item: any) => (
                        <Option key={item.zma_ts_cap} value={item.zma_ts_cap}>
                          {item.zma_ts_cap_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="gioi_tinh" label="Giới tính">
                  <Select
                    size="middle"
                    placeholder="Chọn giới tính"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {gioitinh &&
                      gioitinh.map((item: any) => (
                        <Option key={item.gioitinh} value={item.gioitinh}>
                          {item.gioitinh_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="material_type" label="Material Type">
                  <Select
                    size="middle"
                    placeholder="Chọn Material Type"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {materialtype &&
                      materialtype.map((item: any) => (
                        <Option
                          key={item.material_type}
                          value={item.material_type}
                        >
                          {item.material_type}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="xman" label="Xman">
                  <Select size="middle" placeholder="Chọn Xman" allowClear>
                    {xman &&
                      xman.map((item: any) => (
                        <Option key={item.xman} value={item.xman}>
                          {item.xman}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
              <Col className="flex justify-end mt-4" span={8}>
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    onClick={handleReset}
                  >
                    Hủy
                  </Button>
                  <Button type="submit">Tìm kiếm</Button>
                </Space>
              </Col>
            </Row>
          </Content>
        </Form>
        <Table
          rowKey={(record) => record.branch_code}
          columns={columnBottoms}
          size="middle"
          className="customTable mt-2"
          dataSource={lstAllocation?.data}
          scroll={{ x: 958 }}
          loading={getAllocationLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: lstAllocation?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange(page, size) {
              history.push(`/declare?page=${page}&page_size=${size}`, {
                cart: cart,
                page: page,
                page_size: size,
              });
            },
            // onChange: HocChangePagination(history),
          }}
        />

        {/* popup yêu cầu phê duyệt */}
        <Modal
          open={modalOpen}
          onCancel={() => {
            setModalOpen(false);
          }}
          footer={null}
          width={'50%'}
        >
          <Content className="w-full">
            <p className="text-2xl font-bold">Gửi yêu cầu phê duyệt giỏ hàng</p>
            <Divider style={{ margin: '20px 0' }} />
            <div>
              <p className="text-base">
                Bạn có chắc muốn gửi yêu cầu phê duyệt giỏ hàng lên cung ứng chi
                nhánh?
                <br />
                <span className="text-red-500 font-medium">
                  Lưu ý: khi đơn hàng gửi lên chi nhánh, bạn không thể đặt thêm
                  hàng.
                </span>
              </p>
            </div>
            <Row justify="end" className="mt-4">
              <Button
                onClick={() => {
                  setModalOpen(false);
                }}
                customClass="text-neutral-50 mr-2"
                bgColor="white"
              >
                Huỷ
              </Button>
              <Button onClick={requestApprovalToBranch}>Gửi yêu cầu</Button>
            </Row>
          </Content>
        </Modal>

        {/* Xem chi tiết */}
        <Modal
          title={
            <span className="custom-modal-header">Thông tin sản phẩm</span>
          }
          visible={isModalVisible}
          width={'70%'}
          closeIcon={<CloseOutlined onClick={handleCancel} />}
          style={{ marginTop: '-75px' }}
          footer={null}
        >
          <Divider
            style={{
              borderTop: '1px solid rgba(0, 0, 0, 0.2)',
              marginTop: '8px',
              marginBottom: '0px',
            }}
          />
          <ProductCartInfo
            data={cart_register_detail}
            setMin={modalData?.ChangeValueMin}
            setMax={modalData?.ChangeValueMax}
          />
          <div
            className="flex justify-end"
            style={{
              backgroundColor: '#EFF3F8',
              padding: '16px 36px',
              margin: '-20px -24px',
            }}
          >
            <Button customClass="end" onClick={handleCancel}>
              Đóng lại
            </Button>
          </div>
        </Modal>
      </div>
    </Spin>
  );
});

export default AllocateCapitalRemain;
